import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { Button } from "./Button";
import { useEscape } from "./hooks";

export interface DrawerProps {
  open: boolean;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
}

/** 右侧详情面板，列表上下文保留。编辑表单也在这里。 */
export function Drawer({ open, title, children, footer, onClose }: DrawerProps) {
  useEscape(open, onClose);
  if (!open) return null;
  return createPortal(
    <>
      <div className="ax-backdrop" onMouseDown={onClose} />
      <div className="ax-drawer-host">
        <div className="ax-drawer" role="dialog" aria-modal="true">
          <div className="ax-drawer-head">
            <span>{title}</span>
            <Button variant="ghost" size="sm" iconOnly aria-label="关闭" onClick={onClose}>
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round"><path d="M4 4l8 8M12 4l-8 8" /></svg>
            </Button>
          </div>
          <div className="ax-drawer-body">{children}</div>
          {footer && <div className="ax-drawer-foot">{footer}</div>}
        </div>
      </div>
    </>,
    document.body,
  );
}
